import React, { useRef, useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { AddSingleVehicle } from './trip/AddSingleVehicle';
import { Toast } from 'primereact/toast';
import { AssignTrip } from './AssignTrip';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { PrintTrip } from './PrintTrip';
import { useReactToPrint } from 'react-to-print';
import axiosInterceptor from '../AuthIntercept';
import axios from 'axios'
import useGlobalState, { g_user, API_Root } from "../globalState";
import { ListLoading } from './ListLoading';
import { isChaseVehicle } from './trip/vehicleName';

export const TripListDealership = () =>  {
   const [trips, setTrips] = useState([]);
   const [loading, setLoading] = useState(true);
   const [showAddSingleVeh, setShowAddSingleVeh] = useState(false);
   const [canSaveSingleVeh, setCanSaveSingleVeh] = useState(false);
   const [singleVehToAdd, setSingleVehToAdd] = useState();
   const [showAssign, setShowAssign] = useState(false);
   const toast = useRef(null);
   const [tripToAssign, setTripToAssign] = useState();
   const [showPrint, setShowPrint] = useState(false);
   const [tripToPrint, setTripToPrint] = useState();
   const [dealerships, setDealerships] = useState(undefined);
   const [curDealership, setCurDealership] = useState(undefined);
   const [init, setInit] = useState(false);
   const [user, setUser] = useGlobalState(g_user);
   const printRef = useRef(null);
   const handlePrint = useReactToPrint({
      content: () => printRef.current,
   });

   const getDealerships = () => {
      var dealerArr = [];

      user.adminDealerships.forEach((d) => {
         dealerArr.push({ id: d.id, name: d.dealershipName, admin: true, porter: false });
      });

      user.porterDealerships.forEach((d) => {
         var match = undefined;
         dealerArr.forEach((a) => {
            if (a.id === d.id) {
               match = a;
            }
         });

         if (match !== undefined) {
            match.porter = true;
         } else {
            dealerArr.push({ id: d.id, name: d.dealershipName, admin: false, porter: true });
         }
      });

      setDealerships(dealerArr);
      if (dealerArr.length > 0) {
         setCurDealership(dealerArr[0]);
         getTripsForDealership(dealerArr[0].id);
      } else {
         setLoading(false);
      }
   }

   useEffect(() => {
      if (!init) {
         setInit(true);
         getDealerships();
      }
   }, []);

   const getDealershipDropdown = () => {
      if (dealerships !== undefined && dealerships.length === 1) {
         return <div><h3>Trips For {dealerships[0].name}</h3></div>;
      }
      else if (dealerships !== undefined && dealerships.length > 1) {
         return <div className="flex">
            <label htmlFor="dealerships">Trips For</label>
            <Dropdown value={curDealership} onChange={(e) => selectDealership(e.value)} options={dealerships} optionLabel="name"
               placeholder="Select a dealership" className="" />
         </div>;
      }
      else {
         return <div></div>;
      }
   }

   const selectDealership = (sel) => {
      setCurDealership(sel);
      setTrips([]);
      getTripsForDealership(sel.id);
   }

   const getTripsForDealership = (id, silent = false) => {
      if (!silent) {
         setLoading(true);
      }
      var apiUrl = `${API_Root}api/trip/GetTripsForDealership?id=${id}`;
      axios.get(apiUrl).then((values) => {
         setTrips(values.data || []);
      }).catch(() => {
         if (!silent) {
            setTrips([]);
         }
      }).finally(() => {
         setLoading(false);
      });
   }

   const removeTripPorter = (porterId, tripId) => {
      var apiUrl = `${API_Root}api/trip/RemoveTripPorter?porterId=${porterId}&tripId=${tripId}`;
      axios.get(apiUrl).then((values) => {
         getTripsForDealership(curDealership.id);
      });
   }

   const confirmDeleteTrip = (id) => {
      confirmDialog({
         message: 'Are you sure you want to delete this trip?',
         header: 'Confirmation',
         icon: 'pi pi-exclamation-triangle',
         accept: () => deleteTrip(id),
         reject: null
      });
   }

   const deleteTrip = (id) => {
      var apiUrl = `${API_Root}api/trip/DeleteTrip?id=${id}`;
      axios.get(apiUrl).then((values) => {
         getTripsForDealership(curDealership.id);
      });
   }

   const sourceTemplate = (rowData) => {
      return (
         <div className="w-full">
            <div className="w-full">{rowData.Dealership2.dealershipName ?? "Private address"}</div>
            <div className="w-full">{rowData.Dealership2.streetAddress}</div>
            <div className="w-full">{rowData.Dealership2.city} {rowData.Dealership2.stateAbbr} {rowData.Dealership2.zipCode}</div>
         </div>
      );
   };

   const destinationTemplate = (rowData) => {
      return (
         <div className="w-full">
            <div className="w-full">{rowData.Dealership1.dealershipName ?? "Private address"}</div>
            <div className="w-full">{rowData.Dealership1.streetAddress}</div>
            <div className="w-full">{rowData.Dealership1.city} {rowData.Dealership1.stateAbbr} {rowData.Dealership1.zipCode}</div>
         </div>
      );
   };

   const newTripAdded = () => {
      setShowAddSingleVeh(false);
      getTripsForDealership(curDealership.id);
   }

   const addSingleVehChanged = (dto) => {
      setSingleVehToAdd(dto);
      if (dto.selectedTrip > 0) {
         // Add-to-existing saves from the wizard step and does not change schedule or notes.
         setCanSaveSingleVeh(false);
      }
      else if (dto.selectedTrip === 0) {
         setCanSaveSingleVeh(dto.step == 4 &&
            dto.chaseOriginReady !== false &&
            dto.trip.TripVehicles &&
            dto.locations &&
            dto.trip.TripVehicles.length > 0 &&
            dto.locations.length >= 2 &&
            dto.trip.dealNumber &&
            dto.trip.requestedDeliveryDateTime);
      }
      else {
         setCanSaveSingleVeh(false);
      }
   }

   const saveSingleVehicle = () => {
      var apiUrl = `${API_Root}api/trip/SaveTripv2`;
      if (singleVehToAdd.selectedTrip > 0) {
         apiUrl = `${API_Root}api/trip/AddVehicleToTrip`;
         singleVehToAdd.trip.id = singleVehToAdd.selectedTrip;
      }

      axios.post(apiUrl, singleVehToAdd).then((values) => {
         if (values.data === true) {
            toast.current.show({ severity: 'success', summary: 'Delivery scheduled', detail: 'Your transport request was saved successfully.', life: 4000 });
         }
         else {
            toast.current.show({ severity: 'error', summary: 'Could not save', detail: 'Please check your entries and try again.', life: 4000 });
         }
         newTripAdded();
      });
   }

   const addSingleVehFooter = () => (
      <div className="flex justify-content-end gap-2">
         <Button label="Cancel" icon="pi pi-times" onClick={() => setShowAddSingleVeh(false)} className="p-button-text" />
         <Button label="Submit delivery" icon="pi pi-check" onClick={() => saveSingleVehicle()} disabled={!canSaveSingleVeh} />
      </div>
   );

   const assignPorter = (t) => {
      setTripToAssign(t);
      setShowAssign(true);
   }

   const porterAssigned = () => {
      setShowAssign(false);
      getTripsForDealership(curDealership.id);
   }

   const printTrip = (t) => {
      setTripToPrint(t);
      setShowPrint(true);
   }

   const requestedDateTimeTemplate = (rowData) => {
      var d = new Date(rowData.requestedDeliveryDateTime);
      var formattedDate = d.toLocaleDateString('en-US', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit',
         hour12: true 
      });

      return (
         <div className="w-full">
            <div className="w-full font-bold">{formattedDate}</div>
            <div className="w-full">{isChaseVehicle(rowData) ? 'Chase' : `${rowData.vehicleYear ?? ''} ${rowData.vehicleMake ?? ''} ${rowData.vehicleModel ?? ''}`}</div>
            <div className="w-full">{rowData.estimatedDistance} / {rowData.estimatedDuration}</div>
         </div>
      );

   };

   const statusTemplate = (rowData) => {
      var assigned;
      var completed;

      if (rowData.completed) {
         completed = <Tag value="Complete" severity="success" ></Tag>;
      } else {
         completed = <Tag value="Incomplete" severity="warning" ></Tag>;
      }

      if (rowData.porterId !== undefined && rowData.porterId !== null) {
         assigned = <Tag value={"Assigned to " + rowData.User1.firstName + " " + rowData.User1.lastName} severity="success" ></Tag>;
      } else {
         assigned = <Tag value="Unassigned" severity="warning" ></Tag>;
      }

      return (
         <div className="w-full">
            <div className="w-full">{assigned}</div>
            <div className="w-full">{completed}</div>
         </div>
      );
   };

   const portersTemplate = (rowData) => {
      let chaseCar = rowData.chaseCar;
      let numPorters = rowData.numPorters;

      let slots = [];
      let porters = [];
      let chaser = null;

      for (var i = 0; i < rowData.TripPorters.length; i++) {
         if (rowData.TripPorters[i].isChase) {
            chaser = {
               id: rowData.TripPorters[i].userId,
               chase: true,
               label: `${rowData.TripPorters[i].User.firstName} ${rowData.TripPorters[i].User.lastName}`,
               isFilled: true,
               confirmed: rowData.TripPorters[i].confirmed
            };
         }
         else {
            porters.push({
               id: rowData.TripPorters[i].userId,
               chase: false,
               label: `${rowData.TripPorters[i].User.firstName} ${rowData.TripPorters[i].User.lastName}`,
               isFilled: true,
               confirmed: rowData.TripPorters[i].confirmed
            });
         }
      }

      if (chaseCar) {
         if (chaser) {
            slots.push(chaser);
         }
         else {
            slots.push({
               id: 0,
               chase: true,
               label: `Chase Car Needed`,
               isFilled: false,
               confirmed: false
            });
         }
      }

      for (var i = 0; i < numPorters; i++) {
         if (i < porters.length) {
            slots.push(porters[i]);
         }
         else {
            slots.push({
               id: 0,
               chase: false,
               label: `Porter Needed`,
               isFilled: false,
               confirmed: false
            });
         }
      }

      return slots.map((s, i) => {
         let classes = "relative w-full border-round-xl border-1 text-center mb-1 shadow-2 opacity-80 font-bold text-0 text-sm " + (!s.isFilled ? "surface-500" : !s.confirmed ? "bg-yellow-600" : !s.chase ? "bg-green-600" : "bg-blue-600");
         let dlink = s.isFilled ? <i className="pi pi-times-circle absolute right-0 mt-1 mr-1 text-white cursor-pointer text-sm" onClick={() => removeTripPorter(s.id, rowData.id)}></i> : <></>;
         return (<div key={i} className={classes}>{s.label}{dlink}</div>)
      });

   }

   const needsPorter = (rowData) => {
      let chaseCar = rowData.chaseCar;
      let numPorters = rowData.numPorters;

      let slots = [];
      let porters = [];
      let chaser = null;

      for (var i = 0; i < rowData.TripPorters.length; i++) {
         if (rowData.TripPorters[i].isChase) {
            chaser = {
               id: rowData.TripPorters[i].userId,
               chase: true,
               label: `${rowData.TripPorters[i].User.firstName} ${rowData.TripPorters[i].User.lastName}`,
               isFilled: true,
               confirmed: rowData.TripPorters[i].confirmed
            };
         }
         else {
            porters.push({
               id: rowData.TripPorters[i].userId,
               chase: false,
               label: `${rowData.TripPorters[i].User.firstName} ${rowData.TripPorters[i].User.lastName}`,
               isFilled: true,
               confirmed: rowData.TripPorters[i].confirmed
            });
         }
      }

      if ((chaseCar && !chaser) || numPorters > porters.length) {
         return true;
      }
      else {
         return false;
      }
   }

   const actionTemplate = (rowData) => {
      let assign = needsPorter(rowData) ? <Button className="p-1" label="Assign" icon="pi pi-user-plus" text size="small" onClick={() => assignPorter(rowData)} /> : <></>;

      return (
         <div className="flex flex-column gap-1">
            <Button className="p-1" label="Print" icon="pi pi-print" text size="small" onClick={() => printTrip(rowData)} />
            <Button className="p-1" label="Delete" icon="pi pi-trash" text size="small" severity="danger" onClick={() => confirmDeleteTrip(rowData.id)} />
            {assign}
         </div>
      );
   };

   const addButtonTemplate = () => {
      if (curDealership && curDealership.admin) {
         return <Button label="New transport request" icon="pi pi-plus" onClick={() => setShowAddSingleVeh(true)} />;
      }
      else {
         return <div></div>;
      }
   }
                  //<Column header="Status" style={{ minWidth: '12rem' }} body={statusTemplate} />
   return (
      <>
         <ConfirmDialog />
         <div className="card">
            <div className="grid mt-2 ml-2">
               <div className="col-12 md:col-6">
                  {getDealershipDropdown()}
               </div>
               <div className="col-12 md:col-6 text-left md:text-right">
                  {addButtonTemplate()}
               </div>
            </div>
            <div className="table-scroll">
            {loading && trips.length === 0 ? (
               <ListLoading message="Loading active deliveries…" />
            ) : (
            <DataTable value={trips} tableStyle={{ minWidth: '50rem' }} breakpoint="768px" emptyMessage="No active deliveries" loading={loading}>
               <Column header="Delivery" body={requestedDateTimeTemplate} ></Column>
               <Column header="From" style={{ minWidth: '12rem' }} body={sourceTemplate} />
               <Column header="To" style={{ minWidth: '12rem' }} body={destinationTemplate} />
               <Column header="Drivers" style={{ minWidth: '12rem' }} body={portersTemplate} />
               <Column header="Actions" style={{ minWidth: '8rem' }} body={actionTemplate} />
            </DataTable>
            )}
            </div>
            <Toast ref={toast} />
         </div>
         <Dialog header="New transport request" footer={addSingleVehFooter()} visible={showAddSingleVeh} style={{ width: '75vw', height: '90vh' }} breakpoints={{ '960px': '95vw', '641px': '100vw' }} onHide={() => setShowAddSingleVeh(false)}>
            <AddSingleVehicle
               onCancel={() => setShowAddSingleVeh(false)}
               onDataUpdate={(dto) => addSingleVehChanged(dto)}
               onCreated={newTripAdded}
               dealershipId={curDealership?.id}
               userId={user?.user?.id}
               userName={user?.user?.firstName + ' ' + user?.user?.lastName}
               userPhone={user?.user?.phone}>
            </AddSingleVehicle>
         </Dialog>
         <Dialog header="Assign driver" visible={showAssign} style={{ width: '65vw' }} breakpoints={{ '960px': '85vw', '641px': '95vw' }} onHide={() => setShowAssign(false)}>
            <AssignTrip onAssign={porterAssigned} trip={tripToAssign}></AssignTrip>
         </Dialog>
         <Dialog header="Print Trip" visible={showPrint} style={{ width: '65vw' }} breakpoints={{ '960px': '95vw', '641px': '100vw' }} onHide={() => setShowPrint(false)}>
            <div className="w-full text-right mt-2"><Button className="p-2" label="Print" icon="pi pi-print" onClick={() => handlePrint()} /></div>
            <PrintTrip ref={printRef} trip={tripToPrint} dealer={curDealership}></PrintTrip>
         </Dialog>
      </>
   );
}